import { createStoreConfig } from "./common";

const endpoints = {
    getItems: { method: "get", url: "/catalog_data/ages" },
};

export const useAgesStore = createStoreConfig<Age>(endpoints, "age_dictionarie", {
    order_by: "id",
    in: "id__in",
    pk: "id",
    ilike: "type__ilike",
    sortOptions: { primarySortField: "id" }
});

export interface Age {
    id: number;
    type: string;
}

